<template>
    <el-select ref="mySelect"
               v-model="optionValue"
               :multiple="false"
               :disabled="disabled"
               :placeholder="selectTitle"
               clearable
               @clear="clearValue">
      <!-- 全部分组 -->
      <el-option value=""
                 :label="allDataText"
                 v-if="showAllData"
                 class="default-option"
                 style="padding-left:24px;"
                 @click="clearValue">
      </el-option>
      <el-option :value="optionValue"
                 :label="optionLabel"
                 class="options">
        <el-tree id="tree-option"
                 ref="selectTree"
                 :data="options"
                 :node-key="selectProp.value"
                 :props="defaultProps"
                 :expand-on-click-node="false"
                 :default-expanded-keys="[parentId]"
                 @node-click="handleNodeClick" />
      </el-option>
    </el-select>
</template>

<script>
import { defineComponent, ref, watch, onMounted } from "vue";

export default defineComponent({
  name: "mySelect",
  props: {
    //父级ID
    modelValue: { type: String, default: "" },
    //是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    //选择器输入框占位字段
    selectTitle: {
      type: String,
      default: "请选择",
    },
    //树形数据
    options: {
      type: Array,
      default: () => [],
    },
    //树形选择器的配置选项
    defaultProps: {
      type: Object,
      default: () => ({
        children: "children",
        label: "title",
      }),
    },
    //设置树形数据的value和label
    selectProp: {
      type: Object,
      default: () => ({
        value: "value",
        label: "label",
      }),
    },
    //是否显示所有xx 
    showAllData: {
      type: Boolean,
      default: false,
    },
    allDataText: {
      type: String,
      default: "全部分组",
    },
    parentId: { type: String, default: "" }
  },
  emits: ["node-click", "update:modelValue","clear-value"],
  setup (props, context) {
    const mySelect = ref(); //树形选择器ref
    const optionLabel = ref(""); //选择的label
    const optionValue = ref(""); //选择的value
    const selectTree = ref(); //树型控件ref
    
    //根据树形数据和父级ID查询父级名称
    function getLable (arr, value) {
      let res = "";
      function find (arr, value) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i][props.selectProp.value] === value) {
            res = arr[i][props.selectProp.label];
          }
          if (arr[i].children && arr[i].children.length) {
            find(arr[i].children, value);
          }
        }
      }
      find(arr, value);
      return res;
    }
    //点击选择
    function handleNodeClick (node) {
      optionLabel.value = node[props.selectProp.label];
      optionValue.value = node[props.selectProp.value];
      mySelect.value.blur();
      context.emit("node-click", node);
    }
    //清空已选数据
    function clearValue (isEmit = true) {
      optionLabel.value = "";
      optionValue.value = "";
      selectTree.value.setCurrentKey(null);
      if(isEmit){
      context.emit("clear-value");
      }
    }
    watch(
      () => {
        return props.modelValue;
      },
      () => {
        optionLabel.value = getLable(props.options, props.modelValue);
        selectTree.value.setCurrentKey(props.modelValue);
      }
    );
    onMounted(() => {
      if(props.options)
      optionLabel.value = getLable(props.options, props.modelValue);
      selectTree.value.setCurrentKey(props.modelValue);
    });
    return {
      mySelect,
      optionLabel,
      optionValue,
      handleNodeClick,
      clearValue,
      selectTree
    };
  },
});
</script>

<style scoped>
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}
.el-tree-node__label {
  font-weight: normal;
}
.el-tree >>> .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}
.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}
.selectInput {
  padding: 0 5px;
  box-sizing: border-box;
}
</style>
<style lang="scss">
@import "../../../style/manege.scss";
.default-option {
  padding-left: 24px;
}
.el-scrollbar__bar.is-vertical {
  display: none !important;
}
</style>